import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { subscribeTeamAgents, subscribeUsers } from '../data/listeners/users';

// Agents the signed-in user may assign a lead to (CRM revisions Task 1).
//   manager        → their direct team of agents (subscribeTeamAgents)
//   owner/hqadmin  → all active agents in the active tenant
//   agent          → just themselves (a lead they encode is theirs)
// Returns [{ uid, name }]. Shared by NewLeadModal, LeadDrawer and CSV Import.
export function useAssignableAgents() {
  const {
    role, tenantId, authUser, profile,
  } = useAuth();
  const [agents, setAgents] = useState([]);

  useEffect(() => {
    if (role === 'manager' && authUser?.uid) {
      return subscribeTeamAgents({ managerUid: authUser.uid }, (list) =>
        setAgents(list.map((a) => ({ uid: a.uid, name: a.name }))));
    }
    if ((role === 'owner' || role === 'hqadmin') && tenantId) {
      return subscribeUsers({ tenantId }, (list) =>
        setAgents(list
          .filter((u) => u.role === 'agent' && u.active !== false)
          .map((a) => ({ uid: a.uid, name: a.name }))));
    }
    if (role === 'agent' && authUser?.uid) {
      setAgents([{ uid: authUser.uid, name: profile?.name ?? profile?.email ?? 'Me' }]);
      return undefined;
    }
    setAgents([]);
    return undefined;
  }, [role, tenantId, authUser?.uid, profile?.name, profile?.email]);

  return agents;
}
